import { render, staticRenderFns } from "./WorldPopulation.vue?vue&type=template&id=82058556&scoped=true&"
import script from "./WorldPopulation.vue?vue&type=script&lang=js&"
export * from "./WorldPopulation.vue?vue&type=script&lang=js&"
import style0 from "./WorldPopulation.vue?vue&type=style&index=0&id=82058556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82058556",
  null
  
)

export default component.exports